<template>
  <div>
    <div class="content-right">
        <Table stripe :columns="columns1" :data="newCourse" class="table"></Table>
    </div>
  </div>
</template>

<script>
  export default {
    name: "courseDetails",
    props:[
      "newCourse",
    ],
    data(){
      return{
        columns1: [
          {
            title: this.$t('i.courseware.name'),
            key: 'name'
          },
          {
            title: this.$t('i.courseware.orgName'),
            key: 'orgname'
          },
          {
            title: this.$t('i.courseware.course_architecture_names'),
            key: 'course_architecture_names'
          },
          {
            title: this.$t('i.courseware.operation'),
            key:'id',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let Selectid = params.row.id;
                      let type = params.row.type;
                      console.log('id',Selectid);
                      this.Courseware(Selectid,type);
                    }
                  }
                }, '查看')
              ]);
            }
          }
        ],
        data1: [
          {
            name: 'John Brown',
            age: 18,
            address: 'New York No. 1 Lake Park',
            date: '2016-10-03'
          },
          {
            name: 'Jim Green',
            age: 24,
            address: 'London No. 1 Lake Park',
            date: '2016-10-01'
          },
          {
            name: 'Joe Black',
            age: 30,
            address: 'Sydney No. 1 Lake Park',
            date: '2016-10-02'
          },
          {
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park',
            date: '2016-10-04'
          },
          {
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park',
            date: '2016-10-04'
          },
          {
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park',
            date: '2016-10-04'
          },{
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park',
            date: '2016-10-04'
          },
          {
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park',
            date: '2016-10-04'
          }
        ]
      }
    },
    methods: {
      //点击查看按钮(预览)
      async Courseware(Selectid,type){
        let defaultLangValue = localStorage.getItem("defaultLangValue");
        if(!defaultLangValue){
          defaultLangValue = "zh_CN";
        }
        const curJsSessionId = localStorage.getItem("curJsSessionId");
        let open_url = "";
        if("1"==type){
          open_url = this.Constants.serverURL + "/resource/courseware/previewCourseware?id="+Selectid + "&type=" + type + "&flag=front&language="+defaultLangValue;
        }else if("2"==type){
          open_url = this.Constants.serverURL + "/resource/courseware/studyVideo?courseId="+Selectid + "&flag=front&language="+defaultLangValue;
        }
        open_url += "&curJsSessionId=" + curJsSessionId;
        window.open(open_url);
      },
    }
  }
</script>

<style scoped>
  .content-right{
    width: 800px;
    max-height: 333px;
    height: auto;
    background-color: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border: 1px solid #ababab;
  }
</style>



// WEBPACK FOOTER //
// src/pages/study/components/courseDetails.vue